// CodeBlock.tsx — preformatted code, highlighted once the grammars arrive.
//
// The highlighter and its fourteen grammars are a few hundred kilobytes, and
// three of the five routes never show code at all. So they load on demand, and
// until they do the same text renders unhighlighted in the same <pre> — which
// means opening a file shows it immediately and it gains colour a moment
// later, rather than showing a spinner where the code should be.
//
// That fallback is the whole reason this wrapper exists: Suspense with a
// spinner would be easier and worse. A reader who opened a file to check a
// sentence against it can start reading before the colour arrives.
import { Suspense, lazy } from 'react';

const Highlighted = lazy(() => import('./HighlightedCode'));

export default function CodeBlock({ code, language, className }: {
  code: string;
  language?: string;
  className?: string;
}) {
  const plain = <pre className={className}><code>{code}</code></pre>;
  // No language means nothing to load: an extension hljs does not know renders
  // as plain text forever, and pulling the grammars in to decide that would be
  // the download with none of the benefit.
  if (!language) return plain;
  return (
    <Suspense fallback={plain}>
      <Highlighted code={code} language={language} className={className} />
    </Suspense>
  );
}
